import { Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {AngularFireAuth} from "@angular/fire/compat/auth";
import {map} from "rxjs/operators";
import { HttpClient } from "@angular/common/http";
import {environment} from "../../environment/environment";
import {Sentry} from "../../sentry/sentry";

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private afAuth = inject(AngularFireAuth);
  private http = inject(HttpClient);

  constructor() {
    // authState (pas juste signIn()) : couvre aussi la restauration de session Firebase
    // persistée au rechargement de page, pas seulement une connexion active dans l'onglet.
    // takeUntilDestroyed : chaque TestBed instancie son propre AuthService et sans ça
    // l'abonnement survit à la destruction de l'injector (source de "NG0205: Injector
    // has already been destroyed" aléatoires dans d'autres specs quand authState émet en retard).
    this.afAuth.authState.pipe(takeUntilDestroyed()).subscribe(user => {
      Sentry.setUser(user ? {id: user.uid, email: user.email ?? undefined} : null);
    });
  }

  async signIn(email: string, password: string) {
    await this.afAuth.signInWithEmailAndPassword(email, password);
    const userFromDb$ = this.http.get<any>(`${environment.apiUrl}/user/me`, {});
    userFromDb$.subscribe();
    return userFromDb$;
  }

  async getToken(forceRefresh = false): Promise<string> {
    const user = await this.afAuth.currentUser;
    if (!user) throw new Error('User not authenticated');
    return user.getIdToken(forceRefresh); // ⚡ maintenant configurable
  }

  signOut() {
    window.localStorage.removeItem('gameInfo')
    return this.afAuth.signOut();
  }

  isAuth() {
    return this.afAuth.authState.pipe(
      map(authState => {
        return !!authState;
      })
    );
  }

  forgetPassword(email: string): Promise<void> {
    return this.afAuth.sendPasswordResetEmail(email);
  }

  async isUserWithPayingTeam() {
    const userFromDb$ = this.http.get<any>(`${environment.apiUrl}/user/me`);
    userFromDb$.subscribe();
    return userFromDb$.pipe(
      map(user => {
        return user.payingTeam;
      })
    );
  }

  async getUserEmail() {
    const user = await this.afAuth.currentUser;
    return user?.email;
  }
}
